var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},_vm._l((_vm.images),function(image,i){return _c('div',{key:image,ref:"layer",refInFor:true,class:_vm.$style.parallax},[_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(image),expression:"image",arg:"background-image"}],style:({
        transform: ("translateZ(" + (100 * i) + "px)")
      })})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e8df902","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Parallax.vue
// module id = null
// module chunks = 